import React from 'react';

export type DashboardView = 'cells' | 'performance';

interface Props {
  value: DashboardView;
  onChange: (v: DashboardView) => void;
}

const options: { label: string; value: DashboardView }[] = [
  { label: 'Cell view', value: 'cells' },
  { label: 'Performance view', value: 'performance' },
];

const isDev = process.env.NODE_ENV === 'development';

const DashboardViewSegmented = ({ value, onChange }: Props) => (
  <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', gap: 8 }}>
    {options.map((opt, i) => {
      const disabled = opt.value === 'performance' && !isDev;
      return (
        <React.Fragment key={opt.value}>
          {i > 0 && (
            <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: 14, userSelect: 'none' }}>|</span>
          )}
          <span
            onClick={disabled ? undefined : () => onChange(opt.value)}
            style={{
              cursor: disabled ? 'default' : 'pointer',
              fontSize: 14,
              fontWeight: 400,
              color: disabled ? 'rgba(255,255,255,0.2)' : value === opt.value ? '#006B8C' : 'rgba(255,255,255,0.5)',
              userSelect: 'none',
            }}
          >
            {opt.label}
          </span>
        </React.Fragment>
      );
    })}
  </div>
);

export default DashboardViewSegmented;
